<template>
  <div>
    <b-row v-if="checkAccessPrivilege('Payment.Level.BankMaintenance.ManualDeposit.Search')">
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form inline>
              <label class="mr-sm-2" for="sAccountName">Account Name </label>
              <b-input id="sAccountName" type="text" placeholder="" v-model.trim="sAccountName"></b-input>
              &nbsp;&nbsp;
              <label class="mx-sm-2" for="sVIPLevel">Level </label>
              <b-form-select id="sVIPLevel" :plain="true" :options="levels" v-model="sVIPLevel" text-field="Name" value-field="Id">
                <template slot="first">
                  <option :value="null">-- Please select an option --</option>
                </template>
              </b-form-select>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b-button variant="primary" @click="searchReceiptAccount"><i class="fa fa-search"></i> Search</b-button>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-user'></i> Bank Maintenance - Manual Deposit</h3>
              <b-button variant="primary" class="float-right" @click="showManagementModal" v-if="checkAccessPrivilege('Payment.Level.BankMaintenance.ManualDeposit.Management')">VIP Level Management</b-button>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <template v-slot:cell(sn)="data">
                {{data.index+1 + ((currentPage-1)*perPage)}}
              </template>
              <template v-slot:cell(action)="data">
                <b-button class="btn-sm" variant="warning" @click="showChangeReceiptAccount(data.item.Id, data.item.Order, data.item.LevelId)" v-if="checkAccessPrivilege('Payment.Level.BankMaintenance.ManualDeposit.Remove')">Change</b-button>
                <b-button class="btn-sm" variant="danger" @click="removeReceiptAccount(data.item.LevelId, data.item.ReceiptAccountId, data.item.ReceiptAccountName)" v-if="checkAccessPrivilege('Payment.Level.BankMaintenance.ManualDeposit.Remove')">Remove</b-button>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-modal ref="showManagementModal" size="lg" header-bg-variant="primary" hide-footer title="VIP Level Management">
      <div class="d-block">
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="12">
                <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="receiptList" :fields="receiptFields" :current-page="receiptCurrentPage" :per-page="receiptPerPage">
                  <template v-slot:cell(action)="data">
                    <b-button variant="danger" @click="confirmAssignLevel(data.item.receiptAccountId, data.item.receiptName)">Assign</b-button>
                  </template>
                </b-table>
                <nav>
                  <b-pagination :total-rows="getReceiptRowCount(receiptList)" :per-page="receiptPerPage" v-model="receiptCurrentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                </nav>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <b-btn class="mt-3" variant="outline-danger" @click="hideManagementModal">Cancel</b-btn>
    </b-modal>

    <b-modal ref="confirmAssignLevel" @hidden="onAssignModalHide" size="lg" centered header-bg-variant="primary" hide-footer title="Assign VIP Level">
      <div class="mb-3">
        <label for="aVIPLevel">Level</label>
        <b-form-select id="aVIPLevel" :plain="false" v-model="aVIPLevel" :state="$v.aVIPLevel.$error?false:null" @blur.native="$v.aVIPLevel.$touch">
          <option :value="null">-- Please select --</option>
          <option v-for="d in levels" :key="d.Id" :value="d.Id">{{ d.Name }}</option>
        </b-form-select>
        <div v-if="$v.aVIPLevel.$error">
          <div class="invalid-feedback d-block" v-if="!$v.aVIPLevel.required">VIP level is required</div>
        </div>
      </div>
      <div class="mb-3">
        <label for="aVIPOrder">Set Order</label>
        <b-form-input type="text" v-model.trim="aVIPOrder" :state="$v.aVIPOrder.$error?false:null" @focus.native="$v.aVIPOrder.$touch"></b-form-input>
        <div v-if="$v.aVIPOrder.$error">
          <div class="invalid-feedback d-block" v-if="!$v.aVIPOrder.required">Order Number is required</div>
        </div>
      </div>
      <b-button variant="success" @click="assignVIPLevel" :disabled="$v.aVIPLevel.$invalid || $v.aVIPOrder.$invalid">Confirm</b-button>
      <b-button variant="outline-danger" @click="cancelAssignLevel">Cancel</b-button>
    </b-modal>

    <b-modal ref="showChangeReceiptAccount" @hidden="hideChangeReceiptAccount" size="lg" centered header-bg-variant="primary" hide-footer title="Update Receipt Bank Account">
      <div class="mb-3">
        <label for="cLevelId">Level</label>
        <b-form-select id="cLevelId" :plain="false" v-model="cLevelId" :state="$v.cLevelId.$error?false:null" @blur.native="$v.cLevelId.$touch">
          <option :value="null">-- Please select --</option>
          <option v-for="d in levels" :key="d.Id" :value="d.Id">{{ d.Name }}</option>
        </b-form-select>
        <div v-if="$v.cLevelId.$error">
          <div class="invalid-feedback d-block" v-if="!$v.cLevelId.required">VIP level is required</div>
        </div>
      </div>
      <div class="mb-3">
        <label for="cOrder">Set Order</label>
        <b-form-input type="text" v-model.trim="cOrder" :state="$v.cOrder.$error?false:null" @focus.native="$v.cOrder.$touch"></b-form-input>
        <div v-if="$v.cOrder.$error">
          <div class="invalid-feedback d-block" v-if="!$v.cOrder.required">Order Number is required</div>
        </div>
      </div>
      <b-button variant="success" @click="updateReceiptAccount" :disabled="$v.cOrder.$invalid || $v.cLevelId.$invalid">Update</b-button>
      <b-button variant="outline-danger" @click="hideChangeReceiptAccount">Cancel</b-button>
    </b-modal>
  </div>
</template>

<script>
import VueNotifications from 'vue-notifications'
import {Events} from '../../../../events.js'
const {required} = require('vuelidate/lib/validators')
export default {
  name: 'vip-level-bankAccount-table',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      type: 0,
      items: [],
      levels: [],
      receiptList: [],
      fields: [
        { key: 'sn', label: 'S.No' },
        { key: 'VipLevel', label: 'Vip Level' },
        { key: 'ReceiptAccountName', label: 'Receipt Account', sortable: true },
        { key: 'Order', label: 'Order', sortable: true },
        { key: 'action', label: 'Action' }
      ],
      receiptFields: [
        { key: 'receiptAccountId', label: 'Receipt Id' },
        { key: 'receiptName', label: 'Receipt Name' },
        { key: 'action', label: 'Action' }
      ],
      currentPage: 1,
      receiptCurrentPage: 1,
      perPage: 10,
      receiptPerPage: 10,
      assignId: '',
      assignReceiptName: '',
      cId: '',
      cLevelId: '',
      cOrder: '',
      aVIPLevel: null,
      aVIPOrder: 99,
      sAccountName: '',
      sVIPLevel: null
    }
  },
  validations: {
    aVIPLevel: { required },
    aVIPOrder: { required },
    cLevelId: { required },
    cOrder: { required }
  },
  methods: {
    getRowCount (items) {
      return items.length
    },
    getReceiptRowCount (receipt) {
      return receipt.length
    },
    getVIPLevels () {
      this.$http.get(this.API_ENDPOINT + '/payment/viplevel/levels', {headers: { 'Content-Type': 'application/json' }}).then(response => {
        this.levels = response.data.levels
      }).catch(err => {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      })
    },
    async getReceiptList () {
      try {
        let result = await this.$http.get(this.API_ENDPOINT + `/payment/bank/account/getReceiptBankList?type=${this.type}`, { headers: { 'Content-Type': 'application/json' } })
        this.receiptList = result.data.items
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    async searchReceiptAccount () {
      try {
        let querystr = `type=${this.type}&levelId=${this.sVIPLevel || ''}&receiptName=${this.sAccountName}`
        let result = await this.$http.get(this.API_ENDPOINT + `/payment/viplevel/receiptAccount/getlist?${querystr}`, { headers: { 'Content-Type': 'application/json' } })
        this.items = result.data.list
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    showManagementModal () {
      this.$refs.showManagementModal.show()
    },
    hideManagementModal () {
      this.$refs.showManagementModal.hide()
    },
    confirmAssignLevel (id, receiptName) {
      this.assignId = id
      this.assignReceiptName = receiptName
      this.$refs.confirmAssignLevel.show()
    },
    cancelAssignLevel () {
      this.$refs.confirmAssignLevel.hide()
    },
    onAssignModalHide () {
      this.$refs.showManagementModal.show()
    },
    async assignVIPLevel () {
      try {
        let result = await this.$http.post(this.API_ENDPOINT + '/payment/viplevel/receiptAccount/assign', {
          type: this.type,
          levelId: this.aVIPLevel,
          order: this.aVIPOrder,
          receiptId: this.assignId,
          receiptName: this.assignReceiptName
        }, {
          headers: { 'Content-Type': 'application/json' }
        })

        if (result.status === 200) {
          this.searchReceiptAccount()
          this.cancelAssignLevel()
          Events.$emit('alert', VueNotifications.types.success, 'Success', 'Receipt Account Assigned')
        }
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    async removeReceiptAccount (levelId, receiptId, receiptName) {
      try {
        await this.$http.post(this.API_ENDPOINT + '/payment/viplevel/receiptAccount/remove', {
          levelId: levelId,
          receiptId: receiptId,
          receiptName: receiptName,
          type: this.type
        }, {
          headers: { 'Content-Type': 'application/json' }
        })
        this.searchReceiptAccount()
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Receipt Removed Successfully')
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    showChangeReceiptAccount (id, order, levelId) {
      this.$refs.showChangeReceiptAccount.show()
      this.cId = id
      this.cOrder = order
      this.cLevelId = levelId
    },
    hideChangeReceiptAccount () {
      this.$refs.showChangeReceiptAccount.hide()
      this.cId = ''
      this.cOrder = ''
      this.cLevelId = null
    },
    async updateReceiptAccount () {
      try {
        Events.$emit('loader')
        await this.$http.post(this.API_ENDPOINT + '/payment/viplevel/receiptAccount/update', {
          id: this.cId,
          order: parseInt(this.cOrder),
          levelId: this.cLevelId
        }, { headers: { 'Content-Type': 'application/json' } })
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Account Receipt Updated Successfully')
        await this.searchReceiptAccount()
        this.hideChangeReceiptAccount()
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    checkAccessPrivilege (module, title = false) {
      if (!module) return true
      if (title) return (JSON.stringify(this.PRIVILEGE).includes(module))
      return this.PRIVILEGE.includes(module)
    }
  },
  async created () {
    this.searchReceiptAccount()
    this.getReceiptList()
    this.getVIPLevels()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/payment/viplevel/BankAccount/ManualDeposit.vue